<template>
  <div id="registration">
    <RegisterHero :hasVideo="false" />
    <Rules />
  </div>
</template>

<script>
import RegisterHero from "@/components/registration-components/RegisterHero";
import Rules from "@/components/registration-components/Rules";

export default {
  components: {
    RegisterHero,
    Rules
  }
};
</script>

<style lang="scss" scoped>
</style>